// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatMessageSkeleton-goBackSkeletonBtn-S5WDp {
    max-width: 78px;
    height: 26px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
    margin-bottom: 18px;
}

.ChatMessageSkeleton-chatMessageSkeletonContainer-Hk4ek {
    display: grid;
    grid-template-columns: calc(100% - 428px) 404px;
    gap: 24px;
    grid-gap: 24px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.ChatMessageSkeleton-chatMessageSkeletonLsBox-QKL8J {
    padding: 24px;
    background: var(--background-primary);
    border-radius: var(--radius-3);
    min-height: 586px;
}

.ChatMessageSkeleton-chatMessageSkeletonInputContainer-ayjXe {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    border: 1px solid var(--skeleton-primary-bg);
    background: var(--skeleton-primary-bg);
    border-radius: 100px;
    padding: 8px 8px 8px 24px;
    gap: 6px;
    grid-gap: 6px;
}

.ChatMessageSkeleton-chatMessageSkeletonInput-e2XYl {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.ChatMessageSkeleton-chatMessageSkeletonSendIcon-JZYro {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: var(--skeleton-secondary-bg);
}

.ChatMessageSkeleton-chatMessageSkeletonMessageContainer-u7qb5 {
    margin-top: 24px;
}

.ChatMessageSkeleton-chatMessageSkeletonMessageBox-T4anW {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
}

.ChatMessageSkeleton-chatMessageSkeletonMessageImg-qgdKh {
    position: relative;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background: var(--skeleton-secondary-bg);
}

.ChatMessageSkeleton-chatMessageSkeletonMessageInfo-lkq3b {
    background: var(--skeleton-secondary-bg);
    height: 74px;
    border-radius: var(--radius-2);
}

.ChatMessageSkeleton-chatMessageSkeletonMessageBoxReverse-AJJdT {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
        -ms-flex-direction: row-reverse;
            flex-direction: row-reverse;
}

.ChatMessageSkeleton-loaderSkeletonBtnContainer-XR7xR {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    margin-top: 24px;
}

.ChatMessageSkeleton-loaderSkeletonBtn-TQS_C {
    background: var(--skeleton-secondary-bg);
    max-width: 126px;
    height: 44px;
    border-radius: var(--radius-5);
}

@media (min-width: 1200px) {
    .ChatMessageSkeleton-chatMessageSkeletonRsBox-TjJd1 {
        position: sticky;
        top: 100px;
    }
}

@media (max-width: 1199px) and (min-width: 992px) {
    .ChatMessageSkeleton-chatMessageSkeletonRsBox-TjJd1 {
        position: sticky;
        top: 88px;
    }
}

@media (max-width: 991px) {
    .ChatMessageSkeleton-chatMessageSkeletonContainer-Hk4ek {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
    }

    .ChatMessageSkeleton-chatMessageSkeletonLsBox-QKL8J {
        min-height: auto;
    }
}

@media (max-width: 575px) {
    .ChatMessageSkeleton-chatMessageSkeletonMessageImg-qgdKh {
        width: 30px;
        height: 30px;
    }

    .ChatMessageSkeleton-chatMessageSkeletonMessageInfo-lkq3b {
        height: 66px;
    }
}

@media (max-width: 767px) {
    .ChatMessageSkeleton-chatMessageSkeletonLsBox-QKL8J {
        padding: 18px;
    }

    .ChatMessageSkeleton-chatMessageSkeletonSendIcon-JZYro {
        width: 42px;
        height: 42px;
    }

    .ChatMessageSkeleton-chatMessageSkeletonInputContainer-ayjXe {
        padding: 8px 8px 8px 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/ChatMessageSkeleton/ChatMessageSkeleton.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,+CAAwD;IACxD,SAAS;IACT,cAAc;IACd,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,4CAA4C;IAC5C,sCAAsC;IACtC,oBAAoB;IACpB,yBAAyB;IACzB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAc;QAAd,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,8BAA2B;IAA3B,8BAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,oBAAa;QAAb,oBAAa;QAAb,aAAa;QACb,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".goBackSkeletonBtn {\n    max-width: 78px;\n    height: 26px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n    margin-bottom: 18px;\n}\n\n.chatMessageSkeletonContainer {\n    display: grid;\n    grid-template-columns: calc((100% - 404px) - 24px) 404px;\n    gap: 24px;\n    grid-gap: 24px;\n    align-items: flex-start;\n}\n\n.chatMessageSkeletonLsBox {\n    padding: 24px;\n    background: var(--background-primary);\n    border-radius: var(--radius-3);\n    min-height: 586px;\n}\n\n.chatMessageSkeletonInputContainer {\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--skeleton-primary-bg);\n    background: var(--skeleton-primary-bg);\n    border-radius: 100px;\n    padding: 8px 8px 8px 24px;\n    gap: 6px;\n    grid-gap: 6px;\n}\n\n.chatMessageSkeletonInput {\n    flex-grow: 1;\n}\n\n.chatMessageSkeletonSendIcon {\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    background: var(--skeleton-secondary-bg);\n}\n\n.chatMessageSkeletonMessageContainer {\n    margin-top: 24px;\n}\n\n.chatMessageSkeletonMessageBox {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.chatMessageSkeletonMessageImg {\n    position: relative;\n    flex-shrink: 0;\n    width: 62px;\n    height: 62px;\n    border-radius: 50%;\n    background: var(--skeleton-secondary-bg);\n}\n\n.chatMessageSkeletonMessageInfo {\n    background: var(--skeleton-secondary-bg);\n    height: 74px;\n    border-radius: var(--radius-2);\n}\n\n.chatMessageSkeletonMessageBoxReverse {\n    flex-direction: row-reverse;\n}\n\n.loaderSkeletonBtnContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 24px;\n}\n\n.loaderSkeletonBtn {\n    background: var(--skeleton-secondary-bg);\n    max-width: 126px;\n    height: 44px;\n    border-radius: var(--radius-5);\n}\n\n@media (min-width: 1200px) {\n    .chatMessageSkeletonRsBox {\n        position: sticky;\n        top: 100px;\n    }\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n    .chatMessageSkeletonRsBox {\n        position: sticky;\n        top: 88px;\n    }\n}\n\n@media (max-width: 991px) {\n    .chatMessageSkeletonContainer {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .chatMessageSkeletonLsBox {\n        min-height: auto;\n    }\n}\n\n@media (max-width: 575px) {\n    .chatMessageSkeletonMessageImg {\n        width: 30px;\n        height: 30px;\n    }\n\n    .chatMessageSkeletonMessageInfo {\n        height: 66px;\n    }\n}\n\n@media (max-width: 767px) {\n    .chatMessageSkeletonLsBox {\n        padding: 18px;\n    }\n\n    .chatMessageSkeletonSendIcon {\n        width: 42px;\n        height: 42px;\n    }\n\n    .chatMessageSkeletonInputContainer {\n        padding: 8px 8px 8px 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goBackSkeletonBtn": `ChatMessageSkeleton-goBackSkeletonBtn-S5WDp`,
	"chatMessageSkeletonContainer": `ChatMessageSkeleton-chatMessageSkeletonContainer-Hk4ek`,
	"chatMessageSkeletonLsBox": `ChatMessageSkeleton-chatMessageSkeletonLsBox-QKL8J`,
	"chatMessageSkeletonInputContainer": `ChatMessageSkeleton-chatMessageSkeletonInputContainer-ayjXe`,
	"chatMessageSkeletonInput": `ChatMessageSkeleton-chatMessageSkeletonInput-e2XYl`,
	"chatMessageSkeletonSendIcon": `ChatMessageSkeleton-chatMessageSkeletonSendIcon-JZYro`,
	"chatMessageSkeletonMessageContainer": `ChatMessageSkeleton-chatMessageSkeletonMessageContainer-u7qb5`,
	"chatMessageSkeletonMessageBox": `ChatMessageSkeleton-chatMessageSkeletonMessageBox-T4anW`,
	"chatMessageSkeletonMessageImg": `ChatMessageSkeleton-chatMessageSkeletonMessageImg-qgdKh`,
	"chatMessageSkeletonMessageInfo": `ChatMessageSkeleton-chatMessageSkeletonMessageInfo-lkq3b`,
	"chatMessageSkeletonMessageBoxReverse": `ChatMessageSkeleton-chatMessageSkeletonMessageBoxReverse-AJJdT`,
	"loaderSkeletonBtnContainer": `ChatMessageSkeleton-loaderSkeletonBtnContainer-XR7xR`,
	"loaderSkeletonBtn": `ChatMessageSkeleton-loaderSkeletonBtn-TQS_C`,
	"chatMessageSkeletonRsBox": `ChatMessageSkeleton-chatMessageSkeletonRsBox-TjJd1`
};
module.exports = ___CSS_LOADER_EXPORT___;
